import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { CheckedListControl } from "@/Common/Components/Inputs/CheckedListControl";
import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { CheckboxUIModel } from "@/Common/Models/UI/Inputs/CheckboxUIModel";

interface IFileSelectionSettingComponentProps {
    id?: string;
    className?: string;
    style?: React.CSSProperties;
    defaultState: FileSelectionSettingComponentState;

    onClose?: (state?: FileSelectionSettingComponentState) => void;
    onOk?: (state: FileSelectionSettingComponentState) => void;
}

class FileSelectionSettingComponentState {
    public dateTo: Date;
    public dateFrom: Date;
    public categories: Immutable.List<CheckboxUIModel>;
    public wasMouseDownOnOverlay: boolean;

    public static createDefault(): FileSelectionSettingComponentState {
        let state = new FileSelectionSettingComponentState();
        const currentEmployee = sessionStore.getCurrentEmployee();
        state.dateFrom = null;
        state.dateTo = null;
        state.wasMouseDownOnOverlay = false;
        state.categories = [
            CheckboxUIModel.New("CategoryDocId", cacheStore.GetString("DocumentsLabel"), true),
            CheckboxUIModel.New("CategoryLabId", cacheStore.GetString("LaboratoriesLabel"), true),
            CheckboxUIModel.New("CategoryNoteId", cacheStore.GetString("NotesLabel"), true),
            CheckboxUIModel.New("CategorySummaryId", cacheStore.GetString("SummariesLabel"), true),
            CheckboxUIModel.New("CategoryChartsId", cacheStore.GetString("GraphsLabel"), true),
            CheckboxUIModel.New("EncounterFormsId", cacheStore.GetString("FormsLabel"), true),
            CheckboxUIModel.New("ExamRequestId", cacheStore.GetString("ExamRequestsLabel"), true),
            CheckboxUIModel.New("ConsultationRequestId", cacheStore.GetString("ConsultationRequestsLabel"), true),
            CheckboxUIModel.New("PrivateBillId", cacheStore.GetString("InvoicesLabel"), true),
            CheckboxUIModel.New("ImmunizationId", cacheStore.GetString("ImmunizationsLabel"), true)
        ].toImmutable();

        if (currentEmployee.isActiveSiteBC()) {
            state.categories = state.categories.push(CheckboxUIModel.New("Form8Id", cacheStore.GetString("WorkSafeBc_Form8Label"), true));
            state.categories = state.categories.push(CheckboxUIModel.New("Form11Id", cacheStore.GetString("WorkSafeBc_Form11Label"), true));
        }

        return state;
    }
}

class FileSelectionSettingComponent extends React.Component<IFileSelectionSettingComponentProps, FileSelectionSettingComponentState> {
    constructor(props: IFileSelectionSettingComponentProps) {
        super(props);
        this.state = this.props.defaultState ?? FileSelectionSettingComponentState.createDefault();
    }

    public render(): JSX.Element {
        let self = this;
        let categoriesCount = self.state.categories.size;

        let style: React.CSSProperties = this.props.style ? this.props.style : {};

        return (
            <div
                onClick={() => this.state.wasMouseDownOnOverlay && this.props.onClose?.(this.state)}
                onMouseDown={() => this.mutateState(s => s.wasMouseDownOnOverlay = true)}
                className="modal-cover-screen"
            >
                <div
                    id={this.props.id}
                    className={this.props.className}
                    style={style}
                    onClick={e => e.stopPropagation()}
                    onMouseDown={e => this.mutateState(s => {
                        s.wasMouseDownOnOverlay = false;
                        e.stopPropagation();
                    })}
                >
                    <table className="f-content popup-settings-table">
                        <thead>
                            <tr>
                                <th>
                                    <label className=".popup-settings-lblDate">{cacheStore.GetString("DateLabel")}</label>
                                </th>
                                <th>
                                    <div>
                                        <CheckboxControl label={cacheStore.GetString("CategoriesLabel")} style={{ verticalAlign: "top", marginRight: "5px" }} id="allCategories_filePreview" checked={self.state.categories.filter(x => x.Checked === true).size === categoriesCount} onChange={(isChecked: boolean) => self.toggleAllCheckboxes(isChecked)} />
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="popup-settings-dateSelector">
                                        <DateSelector id="dateFromSelector_Id" dateFormat="yyyy-MM-dd" date={this.state.dateFrom} onChangeCallback={date => self.mutateState(s => s.dateFrom = date)} toDayEnabled={true} />
                                    </div>
                                    <div className="popup-settings-dateSelector">
                                        <DateSelector id="dateToSelector_Id" dateFormat="yyyy-MM-dd" date={this.state.dateTo} onChangeCallback={date => self.mutateState(s => s.dateTo = date)} toDayEnabled={true} />
                                    </div>
                                </td>
                                <td>
                                    <CheckedListControl
                                        idModifier="category"
                                        DataSource={this.state.categories}
                                        onChange={(isChecked, id) => self.onCategoryCheckboxChange(isChecked, id)}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="f-footer clearfix">
                        <div className="pull-right">
                            <ButtonControl className="btn btn-default popup-settings-btnCancel apss-settings-btn" onClick={() => self.onCancelClick()} label={cacheStore.GetString("CancelLabel")} />
                            <ButtonControl className="btn btn-primary popup-settings-btnOk apss-settings-btn" onClick={() => self.onOkClick()} label={cacheStore.GetString("Ok_Label")} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private mutateState(mutation: (s: FileSelectionSettingComponentState) => void, then: () => void = null): void {
        let s = new FileSelectionSettingComponentState();
        mutation(s);
        this.setState(s, then);
    }

    private onCancelClick(): void {
        if (this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private onOkClick(): void {
        if (this.props.onOk != null) {
            this.props.onOk(this.state);
        }
    }

    private onCategoryCheckboxChange(isChecked: boolean, id: string): void {
        let self = this;
        let categoryState = self.state;

        if (!IsNullOrWhiteSpace(id)) {
            categoryState.categories.find(x => x.Id == id).Checked = isChecked;
            self.setState(categoryState);
        }
    }

    private toggleAllCheckboxes(isChecked: boolean): void {
        let self = this;
        let allCategories = this.state.categories;

        if (isChecked) {
            allCategories.map(x => x.Checked = true);
            self.mutateState(s => s.categories = allCategories);
        }
        else {
            allCategories.map(x => x.Checked = false);
            self.mutateState(s => s.categories = allCategories);
        }
    }
}

export { FileSelectionSettingComponent, FileSelectionSettingComponentState };
